import {useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {t} from "i18next";
import {Button, Card, Form, Input} from "antd";
import PermissionGroup from "./PermissionGroup";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";

export default function RoleCreateEdit()
{
    const {roleId} = useParams();
    const history = useHistory();

    const formRef = useRef();
    const [role, setRole] = useState({
        permissionIdList: []
    });
    const [selectedPermissions, setSelectedPermissions] = useState([])

    const getRole = async () => {
        if(roleId)
        {
            const resp = await ApiService.Role.GetRole(roleId);
            if(resp.success)
            {
                setRole(resp.data);
            }
        }
    }

    useEffect(() => {
        getRole();
    }, [])

    useEffect(() => {
        formRef.current.setFieldsValue(role)
    }, [role])

    const onFinish = async () => {
        const data = {
            ...formRef.current.getFieldsValue(),
            permissionIdList: role.permissionIdList
        };
        if(roleId)
        {
            const res = await ApiService.Role.EditRole(roleId, data);
        }
        else
        {
            const res = await ApiService.Role.CreateRole(data);
            if(res.success)
            {
                history.push(`/app/system/roles/edit/${res.data}`)
            }
        }
    }

    return (
        <SimpleLayout>
            <Card
                title={!roleId ? t('New Role') : `${t('Edit Role')} - ${role.name}`}
            >
                <Form
                    ref={formRef}
                    layout={'vertical'}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={t('Name')}
                        name={'name'}
                        required={true}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item>
                        <PermissionGroup
                            selectedPermissions={role.permissionIdList}
                            onChangeSelectedPermissions={(permissions) => {
                                setRole({
                                    ...role,
                                    permissionIdList: permissions
                                })
                            }}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}
